import { Component, OnInit } from "@angular/core";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { FindTripFormGroupInterface } from "../data-access/models/interface/find-trip-form.interface";
import { HomePageUtils } from "./utils/home-page.utils";
import { DatePipe } from "@angular/common";import { OfferServiceList, TestimonialList, TopEventsList, TopHotels } from "../data-access/models/consts/home-page.const";
import { CommunicationService } from "src/app/pages/hotels/ui/communication.service";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { EventSharedService } from "src/app/pages/events/src/app/ui/event-shared.service";

@Component({
  selector: "tic-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss"],
})
export class HomePageComponent implements OnInit {
  topHotelList: any[] = TopHotels;
  topEventsList: any[] = TopEventsList;
  testimonialList: any[] = TestimonialList;
  offerServicesList: any[] = OfferServiceList;

  constructor(private routerService: RouterService,private packageState: EventSharedService,private _commonService:CommunicationService,private facadeCheckout: CheckoutFacade) {
    this.facadeCheckout.resetStore();
    this.packageState.setPackageState({ isPackageSelected: false });
  }

  ngOnInit() {
    this.routerService.scrollToTop();
    // this._commonService.searchFromPage.subscribe(res=>{
    //   this.onSubmitForm(res);
    // })
  }

  onSubmitForm(formDetails: FindTripFormGroupInterface): void {
    let copyFormDetails: any = { ...formDetails };
    const pipe = new DatePipe("en-US");
    copyFormDetails.inboundDate = pipe.transform(
      copyFormDetails.inboundDate,
      "yyyy-MM-dd"
    );
    copyFormDetails.outboundDate = pipe.transform(
      copyFormDetails.outboundDate,
      "yyyy-MM-dd"
    );
    copyFormDetails.paxesChildrenAges = JSON.stringify(
      copyFormDetails.paxesChildrenAges
    );
    const finalizedObject =
      HomePageUtils.finalizedObjectDataTemp(copyFormDetails);
    let forwardRoute = "";
    if (
      +copyFormDetails.packageType == 1 ||
      +copyFormDetails.packageType == 2 ||
      +copyFormDetails.packageType == 3
    ) {
      forwardRoute = PagesRoute.EventPage;
    } else if (+copyFormDetails.packageType == 2) {
      forwardRoute = PagesRoute.FlightsPage;
    }
    this.routerService.navigateAndAddParamsToUrl(
      finalizedObject,
      true,
      forwardRoute
    );
  }
}
